// Версія фронта = хеш у назві main.<hash>.js. Кожен деплой дає новий хеш, тож порівнюємо
// хеш запущеного бандла з тим, що зараз у свіжому index.html на сервері.
const MAIN = /static\/js\/main\.([a-z0-9]+)\.js/;

export const runningVersion = () => {
  const script = [...document.scripts].find((s) => MAIN.test(s.src));
  return script ? script.src.match(MAIN)[1] : null; // null — dev-сервер, перевірку не робимо
};

// Свіжий index.html в обхід кешу браузера (унікальний URL + no-store)
export const fetchLatestVersion = async () => {
  const response = await fetch(`/?__v=${Date.now()}`, { cache: "no-store" });
  if (!response.ok) return null;
  const match = (await response.text()).match(MAIN);
  return match ? match[1] : null;
};
